// ⚠️ MOCK — dados ilustrativos para validação com o cliente.
// Remover este arquivo quando as queries reais forem implementadas (ver PRD §14).
//
// As INTERFACES abaixo são o CONTRATO que as queries GraphQL reais deverão cumprir.
// Foram desenhadas como se fossem o retorno da API — mantê-las estáveis facilita a
// troca do mock por dados reais sem mexer no componente.

// ---------------------------------------------------------------------------
// KPIs (faixa de totalizadores no topo)
// ---------------------------------------------------------------------------
export interface ElectronicSecurityKpis {
    activeEquipment: number;          // total de equipamentos ativos
    accessCount: number;              // equipamentos de controle de acesso
    alarmCount: number;               // equipamentos de alarme
    cameraCount: number;              // câmeras (CFTV)
    checklistsInPeriod: number;       // checklists gerados no período
    openNonConformities: number;      // itens não-conformes ainda em aberto (pending+working+late)
    lateItems: number;                // itens atrasados (status 'late')
    compliancePercent: number;        // % de conformidade no período (ex.: 91.3)
    compliancePercentDelta: number;   // variação em p.p. vs período anterior (ex.: 2.4)
    avgResolutionDays: number;        // tempo médio de resolução, em dias (ex.: 6.2)
}

// ---------------------------------------------------------------------------
// Gráfico 1 — Conformidade por sistema (ColumnChart empilhado)
// OBS: só 'access' possui a condição 'fail' (Alarm é ok|error; CFTV nem tem
// 'condition'). Por isso `fail` = 0 para alarm e cftv — assimetria intencional.
// ---------------------------------------------------------------------------
export interface ComplianceBySystemRow {
    system: 'access' | 'alarm' | 'cftv';
    ok: number;
    error: number;
    fail: number;
}

// ---------------------------------------------------------------------------
// Gráfico 2 — Não-conformidades por status de tratamento (PieChart)
// status mapeia o enum real do item de checklist.
// ---------------------------------------------------------------------------
export interface NonConformityByStatusRow {
    status: 'pending' | 'working' | 'late' | 'done';
    count: number;
}

// ---------------------------------------------------------------------------
// Gráfico 3 — Evolução mensal (LineChart)
// ---------------------------------------------------------------------------
export interface MonthlyEvolutionRow {
    month: string;   // 'MM/YYYY'
    opened: number;  // não-conformidades abertas no mês
    resolved: number; // não-conformidades resolvidas no mês
}

// ---------------------------------------------------------------------------
// Gráfico 4 — Blocos críticos (BarChart horizontal)
// ---------------------------------------------------------------------------
export interface CriticalBlocRow {
    bloc: string;
    nonConformities: number;
}

// ---------------------------------------------------------------------------
// Gráfico 5 — CFTV: falhas por dimensão (ColumnChart)
// dimension = as 4 dimensões reais de CheckListCftvItem.
// ---------------------------------------------------------------------------
export interface CftvFailureByDimensionRow {
    dimension: 'alimentation' | 'alignment' | 'focus' | 'signal';
    camerasWithError: number;
}

// ===========================================================================
// DADOS MOCKADOS (plausíveis para uma unidade fabril)
// ===========================================================================

export const MOCK_KPIS: ElectronicSecurityKpis = {
    activeEquipment: 425,
    accessCount: 148,
    alarmCount: 63,
    cameraCount: 214,
    checklistsInPeriod: 18,
    openNonConformities: 37,
    lateItems: 9,
    compliancePercent: 91.3,
    compliancePercentDelta: 2.4,
    avgResolutionDays: 6.2,
};

// access: 132 + 11 + 5 = 148 · alarm: 57 + 6 = 63 · cftv: 198 + 16 = 214
export const MOCK_COMPLIANCE_BY_SYSTEM: ComplianceBySystemRow[] = [
    {system: 'access', ok: 132, error: 11, fail: 5},
    {system: 'alarm', ok: 57, error: 6, fail: 0},
    {system: 'cftv', ok: 198, error: 16, fail: 0},
];

// abertos (pending+working+late) = 14 + 14 + 9 = 37 (bate com openNonConformities)
export const MOCK_NON_CONFORMITY_BY_STATUS: NonConformityByStatusRow[] = [
    {status: 'pending', count: 14},
    {status: 'working', count: 14},
    {status: 'late', count: 9},
    {status: 'done', count: 41},
];

export const MOCK_MONTHLY_EVOLUTION: MonthlyEvolutionRow[] = [
    {month: '02/2026', opened: 22, resolved: 18},
    {month: '03/2026', opened: 19, resolved: 21},
    {month: '04/2026', opened: 27, resolved: 20},
    {month: '05/2026', opened: 24, resolved: 25},
    {month: '06/2026', opened: 31, resolved: 22},
    {month: '07/2026', opened: 28, resolved: 27},
];

export const MOCK_CRITICAL_BLOCS: CriticalBlocRow[] = [
    {bloc: 'Bloco 07', nonConformities: 12},
    {bloc: 'Almoxarifado', nonConformities: 9},
    {bloc: 'Portaria Principal', nonConformities: 8},
    {bloc: 'Doca 2', nonConformities: 7},
    {bloc: 'Bloco 12', nonConformities: 6},
    {bloc: 'Utilidades', nonConformities: 5},
];

export const MOCK_CFTV_FAILURE_BY_DIMENSION: CftvFailureByDimensionRow[] = [
    {dimension: 'alimentation', camerasWithError: 6},
    {dimension: 'alignment', camerasWithError: 4},
    {dimension: 'focus', camerasWithError: 9},
    {dimension: 'signal', camerasWithError: 3},
];
